import { useQuery } from 'react-query'
import { getServiceOrderById } from '../..'

export default function useServiceOrderById(params: any) {
  const { data, error, isLoading } = useQuery(
    ['serviceOrder', params],
    () => getServiceOrderById(params),
    { enabled: !!params?.id, refetchOnWindowFocus: false }
  )
  return { data, error, isLoading }
}
